var OCS = OCS || {};
OCS.Geometry = OCS.Geometry || {};
OCS.Geometry.Classes = OCS.Geometry.Classes || {};
OCS.Geometry.Functions = OCS.Geometry.Functions || {};
OCS.Geometry.Classes.RequestPromise = new Class({
    Implements: [Class.Thenable, Options, Events],
    options: {
        id: "",
        type: "",
        projection: "",
        simplify: 0
    },
    gm: null,
    method: null,
    bound_methods: {},
    req: null,
    initialize: function (op, gm, method) {
        this.setOptions(op);
        this.bound_methods.on_geometry_fetched = this.on_geometry_fetched.bind(this);
        if(gm) {
            this.gm = gm;
            gm.addEvent(gm.options.geometry_fetched_event, this.bound_methods.on_geometry_fetched);
        }
        this.method = method;


    },
    /*
     *
     *
     * Action Methods
     *
     */
    start: function() {
        var geometry = this.method(this.options);
        if(geometry) {
            if(geometry.class_type === "Request") {
                this.req = geometry;
            } else {
                this.on_geometry_fetched(geometry);
            }

        }
        return this;
    },
    cancel: function() {
        this.gm.removeEvent(this.gm.options.geometry_fetched_event, this.bound_methods.on_geometry_fetched);
        if(this.req) {
            this.req.cancel();
            this.req = null;
        }
        this.reject({message: "Canceled"});
        this.fireEvent('complete', false);
        return this;
    },

    /*
     *
     * Event Listener Methods
     *
     */
    get_key: function() {
        return OCS.Geometry.Functions.getKey(this.options.id, this.options.projection, parseInt(this.options.simplify));
    },
    on_geometry_fetched: function(geometry) {
        if(geometry && geometry.get_key && geometry.get_key() === this.get_key()) {
            this.gm.removeEvent(this.gm.options.geometry_fetched_event, this.bound_methods.on_geometry_fetched);

            this.resolve(geometry);
            this.fireEvent('complete', geometry);
            if(this.req) {
                this.req.destroy();
            }
            this.req = null;
        }

    }
});
